import { useState } from 'react';
import { Button, Checkbox, Tooltip } from '@mui/material';
import { HMIField } from '../../types';

export interface ActionFieldProps {
  field: HMIField;
  value?: unknown;
  disabled?: boolean;
  onRun: () => Promise<unknown>;
}

/**
 * `kind: "action"` fields come in two flavours in the schema:
 *  - access "write"  -> a real command button (Load/Save/Clear/Delete Process, System Info...)
 *  - access "read"   -> a device-reported toggle the operator cannot edit
 *    directly (Open door 1/2, Release sub-assembly) - rendered as a disabled
 *    checkbox reflecting the current device state, matching the BMT screenshot.
 */
function ActionField({ field, value, disabled, onRun }: ActionFieldProps) {
  const [running, setRunning] = useState(false);

  if (field.access === 'read') {
    const isActive = value === 'Open' || value === 'Released' || value === true;
    return (
      <Tooltip title={`Reported by device: ${String(value ?? '--')}`}>
        <Checkbox checked={isActive} disabled />
      </Tooltip>
    );
  }

  const handleClick = async () => {
    setRunning(true);
    try {
      await onRun();
    } finally {
      setRunning(false);
    }
  };

  return (
    <Button
      variant="outlined"
      size="small"
      disabled={disabled || running}
      onClick={handleClick}
    >
      {running ? 'Working...' : field.caption}
    </Button>
  );
}

export default ActionField;
